var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.toggleAll($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])])}
var staticRenderFns = []

export { render, staticRenderFns }